const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20scene%20with%20dramatic%20explosion%20and%20heroic%20protagonist%20silhouette%2C%20warm%20golden%20and%20orange%20lighting%2C%20cinematic%20film%20grain%20texture%2C%20intense%20atmosphere%2C%20professional%20movie%20poster%20aesthetic%2C%20deep%20shadows%20and%20bright%20highlights%2C%20no%20text&width=800&height=450&seq=carousel-01&orientation=landscape',
    tag: '动作冒险',
    title: '2026暑期档动作大片合集',
    desc: '集结年度最燃动作巨制，肾上腺素飙升的观影盛宴',
    count: '36部精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20scene%20with%20couple%20in%20golden%20sunset%20light%2C%20soft%20warm%20tones%2C%20emotional%20cinematic%20photography%2C%20film%20poster%20style%20composition%2C%20dreamy%20atmosphere%2C%20elegant%20visual%20storytelling%2C%20no%20text&width=800&height=450&seq=carousel-02&orientation=landscape',
    tag: '爱情剧情',
    title: '高分爱情电影暖心推荐',
    desc: '精选口碑爱情佳作，感受银幕上的心动瞬间',
    count: '28部精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20film%20scene%20with%20mysterious%20detective%20in%20rainy%20city%20at%20night%2C%20dark%20blue%20and%20warm%20amber%20neon%20lighting%2C%20film%20noir%20cinematic%20style%2C%20tense%20atmosphere%2C%20professional%20movie%20photography%2C%20deep%20contrast%2C%20no%20text&width=800&height=450&seq=carousel-03&orientation=landscape',
    tag: '悬疑烧脑',
    title: '高能反转悬疑片精选',
    desc: '每一部都让你猜不到结局，烧脑体验拉满',
    count: '24部精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20scene%20with%20elegant%20palace%20interior%2C%20warm%20lantern%20light%2C%20traditional%20Chinese%20aesthetic%2C%20rich%20textile%20details%2C%20cinematic%20composition%2C%20soft%20golden%20and%20red%20tones%2C%20epic%20scale%2C%20no%20text&width=800&height=450&seq=carousel-04&orientation=landscape',
    tag: '古装大剧',
    title: '2026年热播古装剧追剧指南',
    desc: '服化道精良口碑炸裂，这个夏天不可错过的古风盛宴',
    count: '18部精选',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            焦点专题
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {carouselItems.map((item, idx) => (
            <div key={idx} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300/50 transition-all duration-300 cursor-pointer">
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full aspect-video object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-semibold">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-sm mt-1.5 line-clamp-2">{item.desc}</p>
                <span className="inline-block mt-3 text-xs font-medium text-accent-600 bg-accent-100 px-2.5 py-1 rounded-full">
                  {item.count}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}